// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"837":"09bc009483f8b216","839":"d0aaa370eec4c886"}[chunkId] + ".js";
};